import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import {
  SlideDescription,
  SlideTitle,
  PointText,
  ContentBulletItem,
  ContentItemText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';

export const SubtitleSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
}) => {
  return (
    <SlideDescription>
      {isEditMode ? (
        <CombinedEditableSection
          slide={slide}
          isEditMode={isEditMode}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          onSave={onSaveEdit}
          onReset={onResetEdit}
          onCancel={onCancelEdit}
          TitleComponent={SlideTitle}
          ContentComponent={PointText}
        />
      ) : (
        <>
          <SlideTitleHeader
            slide={slide}
            slideEdits={slideEdits}
            showEnglishContent={showEnglishContent}
            highlightWord={highlightWord}
          />
          {Array.isArray(slide?.SlideContent) && slide.SlideContent.map((item, idx) => (
            <ContentBulletItem key={idx}>
              <ContentItemText>
                {item.SubTitle && (
                  <>
                    <strong>{item.SubTitle.trim()}:</strong>{' '}
                  </>
                )}
                {item.Text && (highlightWord ? highlightWord(`content_${idx}_text`, item.Text) : item.Text)}
              </ContentItemText>
            </ContentBulletItem>
          ))}
        </>
      )}
    </SlideDescription>
  );
};

export default SubtitleSlide;
